module.exports = __webpack_public_path__ + "img/yemen.efd1cd0a.svg";